import { createContext } from 'react';

import { SelectMode, TRowModel } from './types';

type Props<Row extends TRowModel<Row>> = {
  selectionState: Record<string, SelectMode>;
  handleToggleRow?: (value: SelectMode, record: Row, parentRow: Row | undefined) => void;
  hasMenuExpandColumn?: boolean;
  hasDragSelectColumn?: boolean;
};

export const DataTableContext = createContext({} as Props<any>);
